<template>
  <Modal appear @close="close">
    <template slot="content">
      <transition name="v-fade" mode="out-in">
        <div v-if="isThanks" key="thanks" class="p-config-management-form">
          <div class="p-config-management-form__content c-text--center">
            <h3 class="p-config-management-form__title">
              招待状のメールを<br />ご指定のユーザーに送信いたしました。
            </h3>
            <img
              src="@/assets/img/img-register-provisional.gif"
              alt=""
              width="100"
              height="200"
            />
          </div>
          <div class="p-config-management-form__footer">
            <Button variant="main" size="w230" fsize="f16" @click="close">
              一覧に戻る
            </Button>
          </div>
        </div>
        <div v-else key="input" class="p-config-management-form">
          <div class="p-config-management-form__header">
            <h3 class="p-config-management-form__title">
              SEARCH WRITEのユーザーを追加する
            </h3>
          </div>
          <div class="p-config-management-form__content">
            <div class="c-fieldset">
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">お名前</span>
                <span class="c-required">必須</span>
              </p>
              <div class="c-fieldset__content c-alertPos">
                <Input
                  v-model="params.name"
                  placeholder="例：山田太郎"
                  :class="{ alert: isEdited.name && error.name }"
                />
                <Alert v-if="isEdited.name && error.name">
                  {{ error.name }}
                </Alert>
              </div>
            </div>
            <div class="c-fieldset">
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">フリガナ</span>
                <span class="c-required">必須</span>
              </p>
              <div class="c-fieldset__content c-alertPos">
                <Input
                  v-model="params.nameKana"
                  name="nameKana"
                  placeholder="例：ヤマダタロウ"
                  :class="{ alert: isEdited.nameKana && error.nameKana }"
                />
                <Alert v-if="isEdited.nameKana && error.nameKana">
                  {{ error.nameKana }}
                </Alert>
              </div>
            </div>
            <div class="c-fieldset">
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">メールアドレス</span>
                <span class="c-required">必須</span>
              </p>
              <div class="c-fieldset__content c-alertPos">
                <Input
                  v-model="params.mailAddress"
                  name="mailAddress"
                  placeholder="例：sample@example.com"
                  :class="{
                    alert: isEdited.mailAddress && error.mailAddress
                  }"
                />
                <Alert v-if="isEdited.mailAddress && error.mailAddress">
                  {{ error.mailAddress }}
                </Alert>
              </div>
            </div>
            <div class="c-fieldset">
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">権限</span>
                <span class="c-required">必須</span>
              </p>
              <div class="c-fieldset__content">
                <RadioGroupAuthority v-model="params.isAuthority" />
              </div>
            </div>
            <div
              v-if="!params.isAuthority && projects.length > 0"
              class="c-fieldset"
            >
              <p class="c-fieldset__header">
                <span class="c-fieldset__title">権限を付与するサイト</span>
                <span class="c-required">必須</span>
              </p>
              <div class="c-fieldset__content c-alertPos">
                <div
                  class="c-fieldset__scroll"
                  :class="{
                    alert: isEdited.projectIds && error.projectIds
                  }"
                >
                  <perfect-scrollbar
                    :options="{ suppressScrollX: true, minScrollbarLength: 3 }"
                  >
                    <div class="p-config-management-form__project">
                      <ListItemAuthorityProject
                        v-for="item in projects"
                        v-model="params.projectIds"
                        :item="item"
                        :key="item.id"
                      />
                    </div>
                  </perfect-scrollbar>
                </div>
                <Alert v-if="isEdited.projectIds && error.projectIds">
                  {{ error.projectIds }}
                </Alert>
              </div>
            </div>
          </div>
          <div class="p-config-management-form__footer">
            <div class="c-alertPos">
              <Button
                variant="main"
                size="w230"
                fsize="f16"
                :disabled="isDisabled"
                :class="{ 'is-loading': isProcessing }"
                @click="submit"
              >
                招待を送る
              </Button>
              <Alert v-if="request.error" variant="center">
                {{ request.error }}
              </Alert>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </Modal>
</template>

<script>
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Modal from '@/components/Modal';
import RadioGroupAuthority from '@/components/config/RadioGroupAuthority';
import apiOrganizations from '@/api/organizations';
import utils from '@/utils';
import Validation from '@/validation';
import ListItemAuthorityProject from '@/components/config/ListItemAuthorityProject';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

const STATE = {
  CREATE_USER: 0, // ユーザー作成
  RESET_PASSWORD: 1, // パスワードリセット
  EXISTS_USER: 2, // ユーザー存在チェック
  ACCESS: 3 // アクセス権付与
};
const EMPTY_MESSAGE = '1つ以上選択してください';

export default {
  components: {
    Alert,
    Button,
    Input,
    Modal,
    RadioGroupAuthority,
    ListItemAuthorityProject,
    PerfectScrollbar
  },
  data() {
    return {
      error: {
        mailAddress: '',
        name: '',
        nameKana: '',
        projectIds: ''
      },
      params: {
        mailAddress: '',
        name: '',
        nameKana: '',
        isAuthority: false,
        projectIds: [],
        userId: ''
      },
      request: {
        error: ''
      },
      isEdited: {
        mailAddress: false,
        name: false,
        nameKana: false,
        projectIds: false
      },
      isError: false,
      isProcessing: false,
      isThanks: false,
      state: 0,
      user: null
    };
  },
  computed: {
    accesses() {
      return this.$store.state.organizations.projects.reduce((acc, cur) => {
        acc[cur.projectId] = cur.users.map(user => user.userId);
        return acc;
      }, {});
    },
    organization() {
      return this.$store.getters['view/organization'];
    },
    isDisabled() {
      return this.isError || this.isProcessing;
    },
    projects() {
      return this.$store.state.user.data.projects;
    }
  },
  watch: {
    error: {
      handler() {
        this.checkError();
      },
      deep: true
    },
    params: {
      handler() {
        // 何か入力したらサーバーからのエラーメッセージを消す
        this.request.error = '';
      },
      deep: true
    },
    'params.mailAddress': {
      handler(value, oldValue) {
        const mailAddress = value.trim();
        this.error.mailAddress = new Validation()
          .input()
          .email()
          .test(mailAddress);

        if (typeof oldValue !== 'undefined') {
          this.isEdited.mailAddress = true;
        }
      },
      immediate: true
    },
    'params.name': {
      handler(value, oldValue) {
        const name = value.trim();
        this.error.name = new Validation().input().test(name);

        if (typeof oldValue !== 'undefined') {
          this.isEdited.name = true;
        }
      },
      immediate: true
    },
    'params.nameKana': {
      handler(value, oldValue) {
        const nameKana = value.trim();
        this.error.nameKana = new Validation()
          .input()
          .kana()
          .test(nameKana);

        if (typeof oldValue !== 'undefined') {
          this.isEdited.nameKana = true;
        }
      },
      immediate: true
    },
    'params.projectIds': {
      handler(value, oldValue) {
        if (this.projects.length === 0) {
          this.error.projectIds = '';
          return;
        }
        this.checkEmptyProjectIds();
        if (typeof oldValue !== 'undefined') {
          this.isEdited.projectIds = true;
        }
      },
      immediate: true
    },
    'params.isAuthority': {
      handler(value, oldValue) {
        if (value || this.projects.length === 0) {
          this.error.projectIds = '';
        } else {
          this.checkEmptyProjectIds();
        }
      }
    },
    projects() {
      if (this.projects.length === 0) {
        this.error.projectIds = '';
        this.params.projectIds = [];
      } else {
        this.checkEmptyProjectIds();
      }
    }
  },
  created() {
    this.$store.dispatch('user/getProjects');
  },
  methods: {
    findUsers() {
      return this.$store.state.organizations.users.find(
        user => user.mailAddress === this.params.mailAddress
      );
    },
    checkError() {
      this.isError = utils.checkError(this.error);
    },
    checkEmptyProjectIds() {
      this.error.projectIds = new Validation()
        .check(EMPTY_MESSAGE)
        .test(this.params.projectIds);
    },
    close() {
      this.$emit('close');
    },
    async submit() {
      if (this.isDisabled) {
        return;
      }
      if (this.$constants.isDemo) {
        this.isThanks = true;
        this.$emit('add');
        return;
      }
      this.isProcessing = true;

      try {
        if (this.state === STATE.CREATE_USER) {
          await this.postUser();
          this.state = STATE.RESET_PASSWORD;
        }
        if (this.state === STATE.RESET_PASSWORD) {
          await this.resetPassword();
          this.state = STATE.EXISTS_USER;
        }
        if (this.params.isAuthority) {
          this.isProcessing = false;
          this.isThanks = true;
          this.$emit('add');
        } else {
          if (this.state === STATE.EXISTS_USER) {
            await this.$store.dispatch('organizations/getUsers');
            this.user = this.findUsers();
            if (this.user) {
              this.state = STATE.ACCESS;
            } else {
              this.request.error =
                'エラーが発生しました。ボタンを再度クリックしてください';
              this.isProcessing = false;
            }
          }
          if (this.state === STATE.ACCESS) {
            await this.addProjectAuthority();
          }
        }
      } catch (error) {
        if (error.code === 'too_many_requests') {
          this.request.error =
            'リクエスト回数の上限を超えました。時間を置いて再度クリックしてください';
        } else if (error.response && error.response.data) {
          this.request.error = error.response.data.errors[0].userMessage;
        } else {
          this.request.error =
            'エラーが発生しました。ボタンを再度クリックしてください';
        }
        this.isProcessing = false;
      }
    },
    postUser() {
      const params = {
        mailAddress: this.params.mailAddress,
        name: this.params.name,
        nameKana: this.params.nameKana,
        isAuthority: this.params.isAuthority
      };
      return apiOrganizations.users.post(
        params,
        this.auth.idToken,
        this.organization.organizationId
      );
    },
    resetPassword() {
      const params = {
        email: this.params.mailAddress
      };
      return this.auth.changePassword(params);
    },
    async addProjectAuthority() {
      // プロジェクト一覧とサイトのアクセス権のデータを最新にする
      await Promise.all([
        this.$store.dispatch('organizations/getProjects'),
        this.$store.dispatch('user/getProjects')
      ]);
      const requests = [];
      this.params.userId = this.user.userId;
      this.params.projectIds.forEach(projectId => {
        // プロジェクトが存在するかつアクセス権がない場合のみリクエストに追加する
        if (
          this.projects.some(project => project.id === projectId) &&
          (!this.accesses[projectId] ||
            !this.accesses[projectId].includes(this.params.userId))
        ) {
          const request = apiOrganizations.users.permissions.project.post(
            this.auth.idToken,
            this.organization.organizationId,
            this.params.userId,
            projectId
          );
          requests.push(request);
        }
      });
      return Promise.all(requests).then(response => {
        this.isProcessing = false;
        this.isThanks = true;
        this.$emit('add');
      });
    }
  }
};
</script>
